import { Box, Divider, Typography, useTheme } from "@mui/material";
import StepItems from "./StepItems";
import { blueGrey } from "@mui/material/colors";
import GraphicalStatus from "./GraphicalStatus";
import CustomButton from "../../../../components/CustomButton";
import DownloadLikeLogin from "../../../../../media/images/icons/download-likelogin";
import BoxOutLineSVG from "../../../../../media/images/icons/box-outline";
import BuildingSingleSVG from "../../../../../media/images/icons/building-single";
import TruckOutlineSVG from "../../../../../media/images/icons/truck-outline";
import BigCarSpeed from "../../../../../media/images/icons/bigcar-speed";
import LocationFill from "../../../../../media/images/icons/location-fill";

export default function OrderStatus() {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          mt: 2,
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          borderColor: "info.main",
          borderStyle: "solid",
          gap: "4px",
          borderWidth: "1px",
          borderRadius: "16px",
          flexDirection: "column",
          padding: "8px 4px",
          backgroundColor: "background.default",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "700",
          }}
          textAlign={"center"}
        >
          وضعیت سفارش
        </Typography>
        <StepItems />
        <Divider
          sx={{
            border: "0.5px dashed",
            color: blueGrey[100],
          }}
          variant="middle"
        />
        <GraphicalStatus />
      </Box>
      <Box
        sx={{
          mt: 2,
          paddingBottom: "100px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <CustomButton
            type="outlined"
            rippleColor={theme.palette.info.dark}
            flex={1}
            // loading
            //   onClick={() => handleEditModal()}
            justifyContent="center"
            title="دریافت فایل بارنامه"
            bgColor={theme.palette.success.main}
            textColor={"#fff"}
            fWeight="700"
            fSize="14px"
            px="10px"
            py="12px"
            borderRadius="12px"
            icon2={<DownloadLikeLogin size={22} color={"#fff"} />}
          />
          <CustomButton
            type="outlined"
            rippleColor={theme.palette.info.dark}
            flex={1}
            // loading
            //   onClick={() => handleEditModal()}
            justifyContent="center"
            title="دریافت فایل مجوز"
            bgColor={theme.palette.success.main}
            textColor={"#fff"}
            fWeight="700"
            fSize="14px"
            px="10px"
            py="12px"
            borderRadius="12px"
            icon2={<DownloadLikeLogin size={22} color={"#fff"} />}
          />
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <BoxOutLineSVG color={theme.palette.textColor.main} />

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
              color: "textColor.main",
            }}
          >
            جزئیات سفارش
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                flex: "1",
                padding: "8px",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <BuildingSingleSVG
                  size={22}
                  color={theme.palette.secondary.main}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: blueGrey[400],
                  }}
                >
                  شرکت حمل:
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "textColor.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                آباد تردد فلان (تهران)
              </Typography>
            </Box>
            <Box
              sx={{
                boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                alignItems: "center",
                flex: "1",
                padding: "8px",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <TruckOutlineSVG
                  size={22}
                  color={theme.palette.secondary.main}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: blueGrey[400],
                  }}
                >
                  تعداد کامیون:{" "}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "secondary.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                1عدد{" "}
              </Typography>
            </Box>
            <Box
              sx={{
                boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                flex: "1",
                padding: "8px",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <BuildingSingleSVG
                  size={22}
                  color={theme.palette.secondary.main}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: blueGrey[400],
                  }}
                >
                  گروه بارگیر:{" "}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "textColor.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                تریلر کفی{" "}
              </Typography>
              <Typography
                sx={{
                  color: "textColor.main",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              >
                مسقف یا چادری خاور{" "}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              alignItems: "start",
            }}
          >
            <Box
              sx={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  flex: "1",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <LocationFill
                    size={22}
                    color={theme.palette.secondary.main}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: blueGrey[400],
                    }}
                  >
                    محل بارگیری:
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "textColor.main",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  سیستان و بلوچستان، شهرک فلان، منطقه غرب، انبار فلان{" "}
                </Typography>
              </Box>
              <Box
                sx={{
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  flex: "1",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <LocationFill
                    size={22}
                    color={theme.palette.secondary.main}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: blueGrey[400],
                    }}
                  >
                    محل تخلیه:
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "textColor.main",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  سیستان و بلوچستان، شهرک فلان، منطقه غرب، انبار فلان{" "}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  flex: "1",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <BigCarSpeed size={18} color={theme.palette.secondary.main} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: blueGrey[400],
                    }}
                  >
                    فرستنده:
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "textColor.main",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  شرکت{" "}
                </Typography>
              </Box>
              <Box
                sx={{
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  flex: "1",
                  padding: "8px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <BigCarSpeed size={18} color={theme.palette.secondary.main} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: blueGrey[400],
                    }}
                  >
                    نام گیرنده:{" "}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    color: "textColor.main",
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  احسان قیطاسی
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
